// @flow
import IssueItemPlaceholder from './IssueItemPlaceholder';

export default IssueItemPlaceholder;
